const facebookShareBtn = document.getElementById('facebook-share')
const twitterShareBtn = document.getElementById('twitter-share')
const redditShareBtn = document.getElementById('reddit-share')
const emailShareBtn = document.getElementById('email-share')

const currentUrl = window.location.href
const urlToShare = (currentUrl.indexOf('#') !== -1) ? currentUrl.split('#')[0] : currentUrl

function openFacebookShare (e) {
  const url = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(urlToShare)
  window.open(url, '', 'status=1, height=500, width=400, resizable=yes')
  e.preventDefault()
}

function openTwitterShare (e) {
  const twitterText = twitterShareBtn.getAttribute('data-share-text')
  const url = 'https://twitter.com/intent/tweet?text=' + twitterText + '&url=' + encodeURIComponent(urlToShare) + '&via=carwowuk'
  window.open(url, '', 'status=1, height=420, width=550, resizable=yes')
  e.preventDefault()
}

function openRedditShare (e) {
  const redditTitle = redditShareBtn.getAttribute('data-share-text')
  const url = '//www.reddit.com/submit?url=' + encodeURIComponent(urlToShare) + '&title=' + redditTitle
  window.open(url, '', 'status=1, height=590, width=600, resizable=yes')
  e.preventDefault()
}

function addEmailShare () {
  const emailSubjectLine = emailShareBtn.getAttribute('data-share-text')
  const urlEmail = 'mailto:?subject=' + encodeURIComponent(emailSubjectLine) + '&body=' + encodeURIComponent(urlToShare)
  emailShareBtn.setAttribute('href', urlEmail)
}

addEmailShare()

facebookShareBtn.addEventListener('click', openFacebookShare)
twitterShareBtn.addEventListener('click', openTwitterShare)
redditShareBtn.addEventListener('click', openRedditShare)
